import React from "react";
import ReactGA from "react-ga";

import NavSettingsDropdown from "../utils/NavSettingsDropdown";
import SearchDropdown from "../utils/SearchDropdown";
import NotificationBell from "./NotificationBell";
import {
  SIGN_OUT,
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
} from "../auth/AuthActions";

class NavigationBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: RESOLVE_LOCAL_AUTH_STATE(),
      user: RESOLVE_LOCAL_USER_STATE(),
    };
  }

  componentDidMount() {
    ReactGA.initialize("UA-54935029-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleSignOut = () => {
    const token = this.state.auth.token;
    SIGN_OUT(token);
  };

  render() {
    const { auth } = this.state;
    const is_authenticated = auth.is_authenticated === "true";

    return (
      <nav className="navbar navbar-expand-lg navbar-light i7-navbar">
        <div className="container">
          <a className="navbar-brand" href="/" aria-label="Inertia7 Home" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
            <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: 1.5 }}>
              <span className="i7-logo-text">INERTIA</span>
              <span style={{ color: "var(--brand-dark)" }}>7</span>
            </span>
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            {/* Left: Search */}
            <SearchDropdown />

            {/* Right: Nav items */}
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/home">Home</a>
                </li>
              )}

              {is_authenticated && (
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="/projects/new"
                    style={{ color: "var(--brand-dark)", fontWeight: 700 }}
                  >
                    + New Project
                  </a>
                </li>
              )}

              {!is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/accounts/signin">Sign In</a>
                </li>
              )}

              {!is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/accounts/register">Join! It&apos;s free!</a>
                </li>
              )}

              {/* Notification Bell */}
              {is_authenticated && (
                <li className="nav-item d-flex align-items-center ms-2">
                  <NotificationBell />
                </li>
              )}

              {/* Settings Dropdown - Far Right */}
              <li className="nav-item d-flex align-items-center ms-2">
                <NavSettingsDropdown
                  isAuthenticated={is_authenticated}
                  onSignOut={this.handleSignOut}
                />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default NavigationBar;
